export const DROPS_ANALYTIC_EVENTS = {
    PUBLISH_DROP: 'publish_drop',
    SAVE_DROP: 'save_drop',
    PREVIEW_DROP: 'preview_drop',
    DROP_FORM_STEP_CHANGE: 'drop_form_step_change',
    DROP_DARE_FILTERS: 'drop_dare_filters',
    DROP_ONBOARDING_STARTED: 'drop_onboarding_started',
    DROP_ONBOARDING_COMPLETED: 'drop_onboarding_completed',
    DROP_NOT_QUALIFIED_CREATOR: 'drop_not_qualified_creator',
    SIGN_UP_DROP_NOT_QUALIFIED_CREATOR: 'sign_up_drop_not_qualified_creator',
    DROP_ACTIVE_QUALIFIED_CREATOR: 'drop_active_qualified_creator',
    DROP_INACTIVE_QUALIFIED_CREATOR: 'drop_inactive_qualified_creator',
    SIGN_UP_DROP_ACTIVE_QUALIFIED_CREATOR: 'sign_up_drop_active_qualified_creator',
    SIGN_UP_DROP_INACTIVE_QUALIFIED_CREATOR: 'sign_up_drop_inactive_qualified_creator',
};
